/**
 * File: src/utils/dom.js
 * Mô tả: Thư viện tiện ích thao tác DOM an toàn, tìm kiếm phần tử và tạo phần tử giao diện.
 * Liên quan: src/components/*, src/main.js
 */

/**
 * Chọn một phần tử DOM theo selector
 * @param {string} selector
 * @param {HTMLElement|Document} [parent=document]
 * @returns {HTMLElement|null}
 */
export const $ = (selector, parent = document) => parent.querySelector(selector);

/**
 * Chọn tất cả phần tử DOM khớp với selector
 * @param {string} selector
 * @param {HTMLElement|Document} [parent=document]
 * @returns {HTMLElement[]}
 */
export const $$ = (selector, parent = document) => Array.from(parent.querySelectorAll(selector));

/**
 * Tạo một phần tử HTML với class, thuộc tính và nội dung văn bản an toàn
 * @param {string} tagName - Tên thẻ HTML (div, span, button, ...)
 * @param {Object} [options={}] - Các thuộc tính và class
 * @param {string} [options.className] - Chuỗi class CSS
 * @param {Object.<string, string>} [options.attributes] - Thuộc tính HTML
 * @param {string} [options.text] - Nội dung text an toàn
 * @param {string} [options.html] - Nội dung HTML (chỉ dùng khi an toàn)
 * @returns {HTMLElement}
 */
export const createElement = (tagName, options = {}) => {
  const element = document.createElement(tagName);
  
  if (options.className) {
    element.className = options.className;
  }

  if (options.attributes) {
    Object.entries(options.attributes).forEach(([key, value]) => {
      element.setAttribute(key, value);
    });
  }

  if (options.text !== undefined) {
    element.textContent = options.text;
  } else if (options.html !== undefined) {
    element.innerHTML = options.html;
  }

  return element;
};

/**
 * Thêm hoặc xóa class CSS linh hoạt
 * @param {HTMLElement} element 
 * @param {string} className 
 * @param {boolean} force 
 */
export const toggleClass = (element, className, force) => {
  if (element) {
    element.classList.toggle(className, force);
  }
};
